module.exports = __webpack_public_path__ + "img/img_1.8b7eb636.jpeg";